import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { PermissionPipe } from '../pipes/PermissionPipe';

export const PermissionCheckbox = ({ permission, checked, onChange }) => {
    return (
        <div>
            <Checkbox
                checked={checked}
                onChange={() => onChange(permission)}
                className={'permission-checkbox'}
                disableRipple
                color={'primary'}
            />
            <span>{PermissionPipe(permission)}</span>
        </div>
    );
};
